module.exports = __webpack_public_path__ + "static/back_event_02-d70949078b0a659d2e2554d0f01c452a.jpg";